import { Component, OnInit } from '@angular/core';
import { faChrome, faFirefox, faEdge, faSafari } from '@fortawesome/free-brands-svg-icons';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'app-unitec-footer',
  templateUrl: './unitec-footer.component.html',
  styleUrls: ['./unitec-footer.component.scss']
})
export class UnitecFooterComponent implements OnInit {

  browsersIcons = { faChrome, faFirefox, faEdge, faSafari };
  constructor() { }

  ngOnInit() {
  }
}
